<template>
  <v-app :theme="theme">
    <v-app-bar v-if="showHeaderAndMenu" color="grey-darken-4">
      <v-container class="d-flex align-center px-0">
        <div 
          :class="{ 
            'cursor-pointer': authStore.isAuthenticated
          }"
          @click="authStore.isAuthenticated && $router.push('/')"
        >
          <svg width="229" height="32" viewBox="0 0 229 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 31.3789V-0.00041008H6.71468V31.3789H0Z" fill="currentColor"/>
            <path d="M190.629 19.5025C190.629 23.1422 193.35 25.9195 196.978 25.9195C200.607 25.9195 203.63 23.238 203.63 19.5025C203.63 15.7674 200.808 13.1813 197.18 13.1813C193.451 13.1813 190.629 15.8633 190.629 19.5025ZM210.079 19.5025C210.079 26.1113 204.537 31.3789 197.079 31.3789C189.622 31.3789 184.18 26.1113 184.18 19.5025C184.18 12.8942 189.723 7.53052 197.079 7.53052C204.436 7.62638 210.079 12.8942 210.079 19.5025Z" fill="currentColor"/>
            <path d="M82.7406 25.4895C80.4137 29.062 76.7722 31.3789 71.5118 31.3789C64.026 31.3789 58.7656 26.0686 58.7656 19.4066C58.7656 12.7443 64.026 7.33713 71.5118 7.33713C76.8732 7.33713 80.6158 9.75133 82.8417 13.3238L77.6824 16.4134C76.3673 14.4821 74.749 13.034 71.7139 13.034C67.8697 13.034 65.3411 15.6409 65.3411 19.4066C65.3411 23.1718 67.9713 25.7789 71.7139 25.7789C74.749 25.7789 76.3673 24.3304 77.6824 22.3992L82.7406 25.4895Z" fill="currentColor"/>
            <path d="M101.054 7.86897H108.621L99.213 19.5746L109.03 31.3789H100.747L92.9753 21.7389V31.3789H86.3281V-0.00041008H92.9753V18.3943L101.054 7.86897Z" fill="currentColor"/>
            <path d="M114.513 16.6067H126.247C125.539 13.8066 123.212 12.4549 120.582 12.4549C117.446 12.4549 115.423 13.9994 114.513 16.6067ZM132.013 25.8754C129.586 29.2546 125.944 31.3789 120.582 31.3789C112.894 31.3789 107.836 26.165 107.836 19.4066C107.836 12.7443 112.995 7.33713 120.582 7.33713C128.271 7.33713 132.822 12.4549 132.822 19.117C132.822 19.9859 132.721 21.1444 132.721 21.3377H114.209C114.917 24.2339 117.244 26.165 120.582 26.165C123.516 26.165 125.64 24.91 126.955 23.0753L132.013 25.8754Z" fill="currentColor"/>
            <path d="M136.852 31.3789V18.9617C136.852 12.7532 141.925 7.62876 148.192 7.53052C148.988 7.53052 149.783 7.53052 150.281 7.53052V13.9361C145.506 13.9361 143.417 16.5968 143.417 20.6373V31.3789H136.852Z" fill="currentColor"/>
            <path d="M167.378 25.7446C163.666 25.7446 160.858 23.0242 160.858 19.5266C160.858 16.1263 163.766 13.309 167.378 13.309C170.889 13.309 173.698 16.1263 173.698 19.5266C173.698 23.0242 170.989 25.7446 167.378 25.7446ZM167.98 7.57698C165.171 7.57698 162.663 8.35434 160.958 9.61726V-0.00041008H154.438V19.2351C154.438 25.9387 160.055 31.3789 166.876 31.3789H166.977C174.901 31.3789 180.017 26.2299 180.017 19.5266C180.017 12.823 174.5 7.57698 167.98 7.57698Z" fill="currentColor"/>
            <path d="M228.52 13.5743V7.86897H222.595V-0.00041008H216.067V7.86897H212.953V13.5743H216.167V23.3128C216.167 28.6245 218.979 31.3789 225.407 31.3789H228.621V25.9687H225.909C223.699 25.9687 222.695 25.1815 222.695 23.0176V13.5743H228.52Z" fill="currentColor"/>
            <path d="M43.2788 25.6323H21.9668C18.3135 25.6323 15.3702 22.8545 15.3702 19.4066C15.3702 15.9586 18.3135 13.1813 21.9668 13.1813H43.2788C46.9321 13.1813 49.8754 15.9586 49.8754 19.4066C49.8754 22.8545 46.9321 25.6323 43.2788 25.6323ZM43.2788 7.53052H21.9668C14.9643 7.53052 9.28125 12.7983 9.28125 19.4066C9.28125 26.0152 14.9643 31.3789 21.9668 31.3789H43.2788C50.2814 31.3789 55.9646 26.0152 55.9646 19.4066C55.9646 12.7983 50.2814 7.53052 43.2788 7.53052Z" fill="currentColor"/>
            <path d="M22.3587 23.1719C24.5933 23.1719 26.4056 21.443 26.4056 19.3097C26.4056 17.1771 24.5933 15.4476 22.3587 15.4476C20.124 15.4476 18.3125 17.1771 18.3125 19.3097C18.3125 21.443 20.124 23.1719 22.3587 23.1719Z" :fill="isDark ? '#E21D26' : '#E21D26'"/>
          </svg>
        </div>
        <v-spacer></v-spacer>

        <!-- Desktop menu -->
        <div class="d-none d-md-flex">
          <v-btn
            v-for="item in visibleMenuItems"
            :key="item.path"
            :to="item.path"
            variant="text"
            class="white--text menu-btn"
          >
            {{ $t(`menu.${item.translationKey}`) }}
          </v-btn>

          <!-- Language switcher -->
          <v-menu>
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                :icon="'mdi-earth'"
                class="white--text menu-btn"
              >
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="locale in availableLocales"
                :key="locale.code"
                :value="locale.code"
                @click="changeLocale(locale.code)"
              >
                <v-list-item-title>{{ locale.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn
            variant="text"
            :icon="isDark ? 'mdi-white-balance-sunny' : 'mdi-moon-waning-crescent'"
            @click="toggleTheme"
            class="white--text menu-btn theme-icon"
          >
          </v-btn>

          <v-btn
            v-if="authStore.isAuthenticated"
            variant="text"
            :icon="'mdi-logout'"
            @click="handleLogout"
            class="white--text menu-btn"
          >
          </v-btn>
        </div>

        <!-- Mobile menu -->
        <v-app-bar-nav-icon
          v-if="authStore.isAuthenticated"
          class="d-md-none"
          color="white"
          @click="drawer = !drawer"
        ></v-app-bar-nav-icon>
      </v-container>
    </v-app-bar>

    <!-- Sidebar for mobile menu -->
    <v-navigation-drawer
      v-model="drawer"
      location="right"
      temporary
      color="grey-darken-4"
      theme="dark"
    >
      <v-list>
        <v-list-item
          v-for="item in visibleMenuItems"
          :key="item.path"
          :to="item.path"
          :title="$t(`menu.${item.translationKey}`)"
          :prepend-icon="item.icon"
        ></v-list-item>

        <v-divider class="my-2"></v-divider>

        <v-list-item
          :prepend-icon="'mdi-earth'"
        >
          <v-list-item-title>
            {{ $t('system.language') }}
          </v-list-item-title>
          <template v-slot:append>
            <v-menu>
              <template v-slot:activator="{ props }">
                <v-btn
                  variant="text"
                  v-bind="props"
                  class="white--text"
                >
                  {{ currentLocaleName }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="locale in availableLocales"
                  :key="locale.code"
                  :value="locale.code"
                  @click="changeLocale(locale.code)"
                >
                  <v-list-item-title>{{ locale.name }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-list-item>

        <v-divider class="my-2"></v-divider>
        
        <v-list-item
          :prepend-icon="isDark ? 'mdi-white-balance-sunny' : 'mdi-moon-waning-crescent'"
          @click="toggleTheme"
        >
          <v-list-item-title>
            {{ $t('system.theme') }}
          </v-list-item-title>
        </v-list-item>

        <v-divider class="my-2"></v-divider>
        
        <v-list-item
          v-if="authStore.isAuthenticated"
          :prepend-icon="'mdi-logout'"
          @click="handleLogout"
        >
          <v-list-item-title>
            {{ $t('auth.logout') }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main v-if="!isLockerPage && !isNotFoundPage && !isLoginPage && !isPickupPage">
      <v-container>
        <router-view/>
      </v-container>
    </v-main>

    <router-view v-else/>

    <!-- Logout confirmation dialog -->
    <v-dialog v-model="showLogoutDialog" max-width="400">
      <v-card>
        <v-card-title class="text-h5 pa-4">
          {{ $t('auth.confirmLogout') }}
        </v-card-title>
        <v-card-text>
          {{ $t('auth.confirmLogoutText') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            variant="text"
            @click="showLogoutDialog = false"
          >
            {{ $t('common.cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            variant="text"
            @click="confirmLogout"
          >
            {{ $t('common.confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-if="showHeaderAndMenu"
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </v-app>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { useTheme } from '@/composables/useTheme'
import { useAuthStore } from '@/stores/auth'
import { useSnackbar } from '@/composables/useSnackbar'

const { t, locale } = useI18n()
const route = useRoute()
const { isDark, toggleTheme, theme, setThemeBasedOnSystem } = useTheme()
const authStore = useAuthStore()
const drawer = ref(false)
const showLogoutDialog = ref(false)
const { snackbar } = useSnackbar()

const isLockerPage = computed(() => route.name === 'LockerPage')
const isLoginPage = computed(() => route.name === 'Login')
const isNotFoundPage = computed(() => route.name === 'NotFound')
const isPickupPage = computed(() => route.name === 'Pickup')
const showHeaderAndMenu = computed(() => authStore.isAuthenticated && !isLockerPage.value && !isLoginPage.value && !isNotFoundPage.value && !isPickupPage.value)

const currentLocaleName = computed(() => 
  availableLocales.find(l => l.code === locale.value)?.name
)

const availableLocales = [
  { code: 'ru', name: 'Русский' },
  { code: 'en', name: 'English' },
  { code: 'vi', name: 'Tiếng Việt' }
]

const changeLocale = (newLocale) => {
  locale.value = newLocale
  localStorage.setItem('locale', newLocale)
}

const menuItems = [
  { translationKey: 'users', path: '/users', icon: 'mdi-account-group' },
  { translationKey: 'packages', path: '/packages', icon: 'mdi-package-variant-closed' },
  { translationKey: 'settings', path: '/settings', icon: 'mdi-cog' }
]

const visibleMenuItems = computed(() => {
  if (!authStore.isAuthenticated) return []
  return menuItems
})

const handleLogout = () => {
  showLogoutDialog.value = true
}

const confirmLogout = () => {
  showLogoutDialog.value = false
  authStore.logout()
}

// Listen for changes in the system theme and set initial theme
onMounted(() => {
  const savedTheme = localStorage.getItem('theme')
  if (savedTheme) {
    // User has explicitly set a theme preference
    theme.value = savedTheme
  } else {
    // No user preference, use system preference
    setThemeBasedOnSystem()
    
    // Listen for changes in system preference
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    mediaQuery.addEventListener('change', setThemeBasedOnSystem)
  }
})
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

:deep(svg) {
  color: white;
}

.menu-btn {
  height: 36px !important;
}

.theme-icon {
  transform: scale(0.8);
  padding: 0 !important;
}
</style>

<style>
/* Global styles that apply to the entire application */
.v-container {
  max-width: 1200px !important;
  margin-left: auto;
  margin-right: auto;
}

/* Other global styles */
</style> 